<template>
  <role-form
    ref="formComponent"
    action-type="create"
    :role="role"
    :has-permissions-permission="
      userHasManagementPermission('client_role_permission_store')
    "
    :has-companies-permission="
      userHasManagementPermission('company_permission_store')
    "
    :has-users-permission="userHasManagementPermission('user_permission_store')"
    :loading="loading"
    :submission-error="submissionError"
    :previous-roles-and-permissions="previousRolesAndPermissions"
    @change-previous-roles-and-permissions="
      previousRolesAndPermissions = $event
    "
    @update-fields-validity="fieldsAreValid = $event"
    @update-field="updateFieldValue"
    @save="createRole"
  />
</template>

<script>
import RoleForm from "@/components/SystemManagement/Accounts/ClientRoles/ClientRoleForm";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import { mapActions } from "vuex";

export default {
  name: "RoleCreate",

  components: { RoleForm },

  mixins: [checkPermissionsMixin],

  data() {
    return {
      /**
       * Define the values to create a client role
       */
      role: {
        label: undefined,
        description: null,
        active: true,
        visible: true,
        blocked: false,
        usersMobileAssociates: [],
        usersWebAssociates: [],
        users: [],
        permissions: [],
        companies: []
      },

      fieldsAreValid: true,
      submissionError: null,

      /**
       * Define if the page is loading
       */
      loading: false,

      /**
       * Permissions that were in the selected base client role separated by roles
       */
      previousRolesAndPermissions: []
    };
  },

  methods: {
    ...mapActions(["addClientRoles"]),

    /**
     * Updates the value of a specific field of the role object.
     *
     * @param {Object} data - { fieldName, value }
     */
    updateFieldValue(data) {
      this.role[data.fieldName] = data.value;
    },

    /**
     *
     * Request the BE to create the client role.
     *
     * @return {Promise<void>}
     * @success - Return to client roles list page
     * @error - Set the value of the submissionError variable
     */
    async createRole() {
      if (this.fieldsAreValid) {
        try {
          let dataToSend = this.prepareDataToSend();
          this.loading = true;
          await this.addClientRoles(dataToSend);
          await this.$router.push({ name: "client-roles" });
          this.$toasted.global.toast_success(
            this.$i18n.t("RoleCreatedSuccessfully")
          );
        } catch (error) {
          this.submissionError = error;
        } finally {
          this.loading = false;
        }
      }
    },

    /**
     * Prepares the data to send the server to create the role client
     *
     * @return {{companies: [], visible: boolean, blocked: boolean, permissions: [], description: string,
     *           active: boolean, label: string, users: []}}
     */
    prepareDataToSend() {
      let dataToSend = Object.assign({}, this.role);

      dataToSend.permissions = this.$refs.formComponent.prepareListOfIDsToSend(
        this.role.permissions
      );

      dataToSend.companies = this.$refs.formComponent.prepareListOfObjectsToSend(
        this.role.companies
      );

      dataToSend.users = dataToSend.usersWebAssociates.concat(
        dataToSend.usersMobileAssociates
      );
      delete dataToSend.usersWebAssociates;
      delete dataToSend.usersMobileAssociates;
      dataToSend.users = this.$refs.formComponent.prepareListOfObjectsToSend(
        dataToSend.users
      );

      return dataToSend;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemManagement/Accounts/ClientRoles/ClientRoleCreate.vue